<template>
  <v-container grid-list-md fluid align-baseline pa-0>
  <v-layout row wrap>
    <v-snackbar
        v-model="snackbar"
    >
        {{snackbarText}}
        <v-btn
            color="pink"
            flat
            @click="closeSnackBar"
        >
            Close
        </v-btn>                            
    </v-snackbar>      
    <v-flex xs12>
        <v-dialog
            v-model="dialogViewVrequest"
            fullscreen
            pa-0
            v-show="dialogViewVrequest"
            >



                   <v-card
                        v-if="currvrequestdoc"
                        class="mb-5"
                        color="white lighten-1"
                        ripple
                        >
                        <v-toolbar dark color="primary">
                            <v-toolbar-side-icon @click="closeDialogViewVrequest">
                            <v-icon>close</v-icon>
                                                          
                            </v-toolbar-side-icon>
                            <v-toolbar-title>Verify {{this.currvrequestdoc.name}}</v-toolbar-title>
                            <v-spacer></v-spacer>

                        </v-toolbar>                        





      <v-flex xs12 v-if="currvrequestdoc.verifiers.find(v=>{if(v.userid===member.userid){return true}else{return false}})===undefined || member.member==='cephas_r'">
      <v-card >
          <v-card-text class="caption font-weight-bold">
              <v-layout row  align-space-between justify-start >
                <v-flex xs12 >
                    I, <span class="primary--text" >{{member.firstname}} {{member.lastname}} </span>, hereby certify that the initiator of the account listed above is in fact <span class="primary--text" >{{currvrequestdoc.memberfirstname}} {{currvrequestdoc.memberlastname}}</span> (of line {{currvrequestdoc.memberlineid}}). I have validated this person's identity and thereby <span class="primary--text" >VOUCH FOR</span> this individual.
                </v-flex>
              </v-layout>
              <v-layout row  align-space-between justify-start >
               <v-flex xs4 >
                   <v-btn
                   dark color="primary"
                    @click="vouch"
                    small
                   >
                        I Certify
                   </v-btn>                
               </v-flex>
               <v-flex xs1 >
               </v-flex>
               <v-flex xs7 >
                    <v-select
                    :items="certificationMethodsList"
                    v-model="certificationMethodSelected"
                    label="Certification Method"
                    bottom
                    >
                    </v-select>  
               </v-flex>
              </v-layout>
          </v-card-text>
      </v-card>
      </v-flex>
                        <v-card-title>
                            <template v-if="currvrequestdoc.photoUrl">
                                <v-avatar
                                size="35" 
                                color="grey lighten-2"                                            
                                ><img v-bind:src="currvrequestdoc.photoUrl"></v-avatar>                                          
                            </template>
                            <template v-else>
                                <v-icon>person</v-icon>
                            </template>    
                            
                            <div class="headline pa-1">{{currvrequestdoc.name}} </div>
                            
                        </v-card-title>                        
                        <v-card-text>            





 <!-- START HERE-->
      <template if="currvrequestdoc">
      <v-flex xs12 >
      <v-card >
                
          <v-card-text>            
              
          <v-card>
              <v-card-text>

                <v-flex xs12>
                <v-list>
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Email:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="currvrequestdoc.email">
                            {{currvrequestdoc.email}}
                        </v-flex>  
                                                
                        </v-layout>
                    </v-list-tile>
                    <v-divider inset></v-divider>   
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Phone:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="currvrequestdoc.phone">
                            {{currvrequestdoc.phone}}
                        </v-flex>                                
                        </v-layout>
                    </v-list-tile>    
                    <v-divider inset></v-divider>                              
                </v-list>
                </v-flex>
<!--
              <v-container grid-list-md text-xs-left pa-0 caption id="fieldContainer">
                  <v-layout row  align-space-between justify-start >
                      <v-flex pa-0 xs3 class="fieldlabel">
                          <v-card flat tile><v-card-text>
                              <span>Email:</span>
                          </v-card-text></v-card>
                      </v-flex>
                      <v-flex xs10 class="fieldvalue subheading">
                          <v-card flat tile v-if="currvrequestdoc.email"><v-card-text>{{currvrequestdoc.email}}</v-card-text></v-card>
                      </v-flex>
                  </v-layout>
                  <v-divider  ></v-divider>
                  <v-layout row  align-space-between justify-start >
                      <v-flex pa-0 xs3 class="fieldlabel">
                          <v-card flat tile><v-card-text>
                              <span>Phone:</span>
                          </v-card-text></v-card>
                      </v-flex>
                      <v-flex xs10 class="fieldvalue subheading">
                          <v-card flat tile v-if="currvrequestdoc.phone"><v-card-text>{{currvrequestdoc.phone}}</v-card-text></v-card>
                      </v-flex>
                  </v-layout>
                  <v-divider  ></v-divider>
              </v-container>
-->

              </v-card-text>
          </v-card>

          </v-card-text>

      </v-card>  
      </v-flex>

      <v-flex xs12 >
      <v-card >
                      
          <v-card-text>            
              
          <v-card>
              <v-card-text>
              <v-subheader class="title pa-0" >Claims to be:</v-subheader>     
                <v-flex xs12>
                <v-list>
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Member Name:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="currvrequestdoc">
                            {{currvrequestdoc.memberfirstname}} {{currvrequestdoc.memberlastname}} 
                        </v-flex>  
                                                
                        </v-layout>
                    </v-list-tile>
                    <v-divider inset></v-divider>   
                    <v-list-tile>
                        <v-layout row>
                        <v-flex xs3 class="profilekey caption font-weight-bold">
                            Line:
                        </v-flex>
                        <v-flex class="profilevalue caption" xs9 v-if="currvrequestdoc.memberlineid">
                            {{currvrequestdoc.memberlineid}}
                        </v-flex>                                
                        </v-layout>
                    </v-list-tile>    
                    <v-divider inset></v-divider>                              
                </v-list>
                </v-flex>

<!--
              <v-container grid-list-md text-xs-left pa-0 caption id="fieldContainer">
                  <v-layout row  align-space-between justify-start >
                      <v-flex pa-0 xs3 class="fieldlabel">
                          <v-card flat tile><v-card-text>
                              <span>Member Name:</span>
                          </v-card-text></v-card>
                      </v-flex>
                      <v-flex xs10 class="fieldvalue subheading">
                          <v-card flat tile> <v-card-text>{{currvrequestdoc.memberfirstname}} {{currvrequestdoc.memberlastname}} </v-card-text></v-card>
                      </v-flex>
                  </v-layout>
                  <v-divider  ></v-divider>
                  <v-layout row  align-space-between justify-start >
                      <v-flex pa-0 xs3 class="fieldlabel">
                          <v-card flat tile><v-card-text>
                              <span>Member Line:</span>
                          </v-card-text></v-card>
                      </v-flex>
                      <v-flex xs10 class="fieldvalue subheading">
                          <v-card flat tile ><v-card-text>{{currvrequestdoc.memberlineid}}</v-card-text></v-card>
                      </v-flex>
                  </v-layout>
                  <v-divider  ></v-divider>
              </v-container>
-->              
              </v-card-text>
          </v-card>

          </v-card-text>

      </v-card>  
      </v-flex>      

        <template v-if="currvrequestdoc.linkedin && currvrequestdoc.linkedin.headline">
        <v-flex xs12>
        <v-expansion-panel>
            <v-expansion-panel-content
            key="linkedin"
            >
            <div slot="header">
                                <v-layout row>
                                    <v-flex xs2>
                        <v-avatar
                            size="35" 
                            color="grey lighten-2"                                            
                            ><img v-bind:src="currvrequestdoc.linkedin.pictureUrl"></v-avatar>
                                    </v-flex>
                                    <v-flex xs10 class="font-weight-bold">
                            {{currvrequestdoc.linkedin.headline}}
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12 class="caption primary--text lighten-2">
                                    {{currvrequestdoc.linkedin.industry}}
                                    </v-flex>
                                </v-layout>                                

            </div>
                <v-card  v-if="currvrequestdoc.linkedin && currvrequestdoc.linkedin.headline">
                    <v-card-title>
                        <v-layout column>
                            <v-flex class="caption grey--text">
                                Summary: {{currvrequestdoc.linkedin.summary}}
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text pa-0 class="caption">


                        <template>
                        <v-expansion-panel pa-0>
                            <v-expansion-panel-content
                            key="innerExpanse"
                            >
                            <div slot="header">
                                <v-layout column>
                                    <v-flex xs12 class="text-xs-center body font-weight-bold primary--text ">
                                        POSITION HISTORY
                                    </v-flex>
                                </v-layout>          
                                
                            </div>
                            <v-card flat>
                                <v-card-text>
                                    <v-layout column>
                                        <template v-for="pos in currvrequestdoc.linkedin.positions.values" >
                                        <v-flex :key="pos.id">
                                            <v-layout pt-2 row>
                                                <v-flex ml-3 class="flexlabel" xs3>
                                                    {{pos.title}}
                                                </v-flex>
                                                <v-flex class="flexvalue" ml-2 xs9>
                                                    {{pos.summary}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider :key="'v-divider-' + pos.id"></v-divider>
                                        </template>
                                    </v-layout>            

                                </v-card-text>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </template>


                    </v-card-text>
                </v-card>

            </v-expansion-panel-content>
        </v-expansion-panel>
        </v-flex>
        </template>


      <v-flex xs12 >
      <v-card >
          <v-card-title>
              <v-alert
                :value="true"
                type="warning"
              >
                This Account is Pending Verification
              </v-alert>  
              <div v-if="currvrequestdoc.verifiers" class="subheading">Verifications {{currvrequestdoc.verifiers.length}} out of 2</div>
              <div v-else class="subheading">Verifications 0 out of 2</div>
          </v-card-title>
          <v-card-text>
              <div class="caption">Remember, your account must be verified by at least 2 registered chapter members before your access is authorized.</div>
          </v-card-text>
      </v-card>
      </v-flex>

      <v-flex xs12>
      <template v-if="currvrequestdoc.verifiers">
        <v-subheader>{{currvrequestdoc.verifiers.length}} out of 2 members have vouched</v-subheader>
        <v-expansion-panel>
          <v-expansion-panel-content
            v-for="(v,i) in currvrequestdoc.verifiers"
            :key="i"
          >
            <div slot="header">{{v.name}}</div>
            <v-card>
              <v-card-text>


                    <v-flex xs12>
                    <v-list>
                        <v-list-tile>
                            <v-layout row>
                            <v-flex xs3 class="profilekey caption font-weight-bold">
                                Date:
                            </v-flex>
                            <v-flex class="profilevalue caption" xs9 v-if="v.dateverified">
                                {{v.dateverified}}
                            </v-flex>  
                                                    
                            </v-layout>
                        </v-list-tile>
                        <v-divider inset></v-divider>   
                        <v-list-tile>
                            <v-layout row>
                            <v-flex xs3 class="profilekey caption font-weight-bold">
                                Line:
                            </v-flex>
                            <v-flex class="profilevalue caption" xs9 v-if="v.line">
                                {{v.line}}
                            </v-flex>                                
                            </v-layout>
                        </v-list-tile>    
                        <v-divider inset></v-divider>    
                        <v-list-tile>
                            <v-layout row>
                            <v-flex xs3 class="profilekey caption font-weight-bold">
                                Method:
                            </v-flex>
                            <v-flex class="profilevalue caption" xs9 v-if="v.methodofverification">
                                {{v.methodofverification}}
                            </v-flex>                                
                            </v-layout>
                        </v-list-tile>    
                        <v-divider inset></v-divider>                                                      
                    </v-list>
                    </v-flex>
<!--                  
                    <v-layout v-bind:key="'verifier_edate_vlayout-' + v.dateverified" row  align-space-between justify-start >
                        <v-flex pa-0 xs3 class="fieldlabel">
                            <v-card flat tile><v-card-text>
                                <span>Date:</span>
                            </v-card-text></v-card>
                        </v-flex>
                        <v-flex xs10 class="fieldvalue subheading">
                            <v-card flat tile v-if="v.name"><v-card-text>{{v.dateverified}}</v-card-text></v-card>
                        </v-flex>
                    </v-layout>
                    <v-divider  v-bind:key="'verifier_edate_divider-' + v.dateverified" ></v-divider>

                    <v-layout v-bind:key="'verifier_eline_vlayout-' + v.dateverified" row  align-space-between justify-start >
                        <v-flex pa-0 xs3 class="fieldlabel">
                            <v-card flat tile><v-card-text>
                                <span>Line:</span>
                            </v-card-text></v-card>
                        </v-flex>
                        <v-flex xs10 class="fieldvalue subheading">
                            <v-card flat tile v-if="v.line"><v-card-text>{{v.line}}</v-card-text></v-card>
                        </v-flex>
                    </v-layout>
                    <v-divider  v-bind:key="'verifier_eline_divider-' + v.dateverified" ></v-divider>              

                    <v-layout v-bind:key="'verifier_emethod_vlayout-' + v.dateverified" row  align-space-between justify-start >
                        <v-flex pa-0 xs3 class="fieldlabel">
                            <v-card flat tile><v-card-text>
                                <span>Verify Method:</span>
                            </v-card-text></v-card>
                        </v-flex>
                        <v-flex xs10 class="fieldvalue subheading">
                            <v-card flat tile v-if="v.methodofverification"><v-card-text>{{v.methodofverification}}</v-card-text></v-card>
                        </v-flex>
                    </v-layout>
                    <v-divider  v-bind:key="'verifier_evmethod_divider-' + v.dateverified" ></v-divider>                            
-->
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
<!--
      <v-card v-if="currvrequestdoc.verifiers.length>0">
        <v-card-title>
          Verifiers
        </v-card-title>
        <v-card-text>
            <template v-for="v in currvrequestdoc.verifiers">
              <v-layout v-bind:key="'verifier_date_vlayout-' + v.dateverified" row  align-space-between justify-start >
                  <v-flex pa-0 xs3 class="fieldlabel">
                      <v-card flat tile><v-card-text>
                          <span>Date:</span>
                      </v-card-text></v-card>
                  </v-flex>
                  <v-flex xs10 class="fieldvalue subheading">
                      <v-card flat tile v-if="v.name"><v-card-text>{{v.dateverified}}</v-card-text></v-card>
                  </v-flex>
              </v-layout>
              <v-divider  v-bind:key="'verifier_date_divider-' + v.dateverified" ></v-divider>

              <v-layout v-bind:key="'verifier_name_vlayout-' + v.dateverified" row  align-space-between justify-start >
                  <v-flex pa-0 xs3 class="fieldlabel">
                      <v-card flat tile><v-card-text>
                          <span>Member Name:</span>
                      </v-card-text></v-card>
                  </v-flex>
                  <v-flex xs10 class="fieldvalue subheading">
                      <v-card flat tile v-if="v.name"><v-card-text>{{v.name}}</v-card-text></v-card>
                  </v-flex>
              </v-layout>
              <v-divider  v-bind:key="'verifier_name_divider-' + v.dateverified" ></v-divider>

              <v-layout v-bind:key="'verifier_line_vlayout-' + v.dateverified" row  align-space-between justify-start >
                  <v-flex pa-0 xs3 class="fieldlabel">
                      <v-card flat tile><v-card-text>
                          <span>Line:</span>
                      </v-card-text></v-card>
                  </v-flex>
                  <v-flex xs10 class="fieldvalue subheading">
                      <v-card flat tile v-if="v.line"><v-card-text>{{v.line}}</v-card-text></v-card>
                  </v-flex>
              </v-layout>
              <v-divider  v-bind:key="'verifier_line_divider-' + v.dateverified" ></v-divider>              

              <v-layout v-bind:key="'verifier_vmethod_vlayout-' + v.dateverified" row  align-space-between justify-start >
                  <v-flex pa-0 xs3 class="fieldlabel">
                      <v-card flat tile><v-card-text>
                          <span>Verify Method:</span>
                      </v-card-text></v-card>
                  </v-flex>
                  <v-flex xs10 class="fieldvalue subheading">
                      <v-card flat tile v-if="v.methodofverification"><v-card-text>{{v.methodofverification}}</v-card-text></v-card>
                  </v-flex>
              </v-layout>
              <v-divider  v-bind:key="'verifier_vmethod_divider-' + v.dateverified" ></v-divider>                            
            </template>
        </v-card-text>
      </v-card>
      -->
      </v-flex>      
      </template>
<!-- END HERE -->
                        </v-card-text>

                   </v-card>
 



            </v-dialog>
    </v-flex>


    <v-flex xs12>

        <div class="font-weight-medium title pa-0">Vouch for Users</div>
        <div class="body-1 pa-0">Requesting Full Member-Access </div>
        <div class="font-weight-medium subheading pt-3" >Non-Verified User List</div>
          <template v-for="(item, index) in allVrequestDocs">
            
            <v-list two-line dense v-bind:key="`vlist-${item.vrequestid}`" >

            <v-list-tile :key="`vlisttile-${index}`" avatar ripple @click="viewVrequest(item)">
              <v-list-tile-avatar>
                <template>
                <v-icon >person</v-icon>
                </template>
              </v-list-tile-avatar>                
              <v-list-tile-content>
                <v-list-tile-title> {{ item.memberfirstname }} {{ item.memberlastname }}</v-list-tile-title>
                <!--<v-list-tile-sub-title class="text--primary">{{ new Date(item.datecreated).toLocaleDateString('en-GB', { day : 'numeric', month : 'short', year : 'numeric' }) }} - posted by {{ item.authorname }} </v-list-tile-sub-title>-->
                <v-list-tile-sub-title>{{ item.memberlineid }}</v-list-tile-sub-title>
              </v-list-tile-content>
            <v-list-tile-action>
                <v-icon>chevron_right</v-icon>
            </v-list-tile-action>
            </v-list-tile>

            </v-list>
            <v-divider :key="`divider-${index}`"></v-divider>
          </template>
        
    </v-flex>

  </v-layout>
  </v-container>
</template>

<script>
 import moment from 'moment'
const DATEFORMAT = "ddd, MMM D h:mmA"

  export default {
    data () {
        return {            
            dialogViewVrequest: false,
            currvrequestdoc: false,
            snackbar: false,
            snackbarText: null,
            certificationMethodSelected: null,
            certificationMethodsList: ['LinkedIn Profile Sync', 'Phone Call', 'Email', 'General Assumption']

           
        }
    },
    created () {

        //TODO: variablize the entire page to be used for all post types based this.$route.path
        //console.log('.............route.name = ' , this.$route)

        
    },
    computed: {
      myColor () {
         return this.$store.getters.myColor
      },         
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      lines () {
        return this.$store.getters.lines
      },        
      colorMain () {
          return this.$store.getters.colorMain
      },
      allVrequestDocs () {
          return this.$store.getters.allVrequestDocs
      }          
    },
    watch: {

    },
    methods: {
        viewVrequest: function (objVrequest){
          if(objVrequest.verifiers){
            objVrequest.verifiers = objVrequest.verifiers.map(v=>{
                v.dateverified = moment(v.dateverified).format(DATEFORMAT)
                return v
            })  
          }


            this.currvrequestdoc = objVrequest
            this.openDialogViewVrequest()
        },
        openDialogViewVrequest: function (){
            this.dialogViewVrequest = true
        },
        closeDialogViewVrequest: function (){
            this.dialogViewVrequest = false
            this.currvrequestdoc = null
        },
        openSnackBar: function (){
            this.snackbar = true
        },
        closeSnackBar: function (){
            this.snackbar = false
            this.snackbarText = null
        },
        vouch: function (){
            var dt = new Date();
            var tmpdatemodified = dt.getTime()    

            var tmplines = this.$store.getters.lines
            var tmpmbrline = this.$store.getters.member.lineid
            if(tmplines){
                var tmpobjmbrline = tmplines.find(function(e) {
                    return e.lineid === tmpmbrline
                })

                if(tmpobjmbrline){
                   tmpmbrline = tmpobjmbrline.lineseason + tmpobjmbrline.lineyear
                }
            }

            
            var objVerification = new Object()
            objVerification.vrequestid = this.currvrequestdoc.vrequestid
            objVerification.org = this.currvrequestdoc.memberorg
            objVerification.chapter = this.currvrequestdoc.memberchapter
            objVerification.userid = this.$store.getters.member.userid
            objVerification.name = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
            objVerification.line = tmpmbrline
            objVerification.dateverified = tmpdatemodified
            objVerification.methodofverification = this.certificationMethodSelected
            this.$store.dispatch('vouchForUser',objVerification).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('verification vouchForUser', errmsg) 
                this.closeDialogViewVrequest()
                this.snackbarText="Failed to vouch response."
                this.openSnackBar()
            }else{
                //console.log('successfully added message') 
                this.closeDialogViewVrequest()
                this.snackbarText="Vouch response created."                
                this.openSnackBar()
            }
            })             
        }
       
    }
  }
</script>

<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}
.chat-card{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-me{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}

.chat-card-date{
    text-align: right;
    margin-right:15px;
    color:dimgrey;
}
</style>